import { Sparkles } from 'lucide-react';

interface PreviewModeToggleProps {
  isPreviewMode: boolean;
  onToggle: () => void;
}

export function PreviewModeToggle({ isPreviewMode, onToggle }: PreviewModeToggleProps) {
  return (
    <button
      onClick={onToggle}
      className={`px-3 py-1.5 rounded-md text-sm font-medium transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 flex items-center gap-2 ${
        isPreviewMode
          ? 'bg-blue-600 text-white hover:bg-blue-700 focus:ring-blue-500'
          : 'bg-gray-700 text-gray-200 hover:bg-blue-600 hover:text-white focus:ring-blue-500'
      }`}
      aria-label={isPreviewMode ? 'Exit new shop preview' : 'Try new shop preview'}
      title={isPreviewMode ? 'Exit New Shop Preview' : 'Try New Shop (Preview)'}
    >
      <Sparkles className="w-4 h-4" aria-hidden="true" />
      <span className="hidden sm:inline">
        {isPreviewMode ? 'Exit Preview' : 'Try New Shop'}
      </span>
    </button>
  );
}
